import { ReportColumnConfig } from "components/ReportGrid_New/types";

export const NARG_CONTROL_SHEET_V5_REPORT = "NARG Control Sheet V5 Report";
export const NARG_CONTROL_SHEET_V5_REPORT_GRID_TITLE = "nargControlSheetV5";

export const reportColumns: ReportColumnConfig[] = [
  { name: 'claimReference', title: 'Claim Ref.', width: '150' },
  { name: 'bodyshop', title: 'Bodyshop', width: '200' },
  { name: 'activeWebID', title: 'Active Web ID' },
  { name: 'status', title: 'Status' },
  { name: 'claimSource', title: 'Claim Source' },
  { name: 'liability', title: 'Liability' },
  { name: 'isThirdParty', title: 'Is Third Party' },
  { name: 'createdDate', title: 'Created Date', type: 'date' },
  { name: 'ownerName', title: 'Owner Name' },
  { name: 'manufacturer', title: 'Manufacturer' },
  { name: 'model', title: 'Model' },
  { name: 'regmark', title: 'Vehicle Reg.' },
  { name: 'notificationSent', title: 'Notification Sent', type: 'number' },
  {
    name: 'notificationAcknowledged',
    title: 'Notification Acknowledged',
    type: 'number',
  },
  {
    name: 'bookingInDate',
    title: 'Booking In Date',
    type: 'date',
  },
  { name: 'estimatedDTG', title: 'Estimated DTG', type: 'date' },
  { name: 'labourHours', title: 'Labour Hours', type: 'number' },
  { name: 'possibleTotalLoss', title: 'Possible Total Loss' },
  { name: 'engineerInstructedDate', title: 'Engineer Instructed Date', type: 'date' },
  { name: 'declaredTotalLossDate', title: 'Declared Total Loss Date' },
  { name: 'confirmedOnSiteDate', title: 'Confirmed On Site Date', type: 'date' },
  { name: 'estimatedCompletionDate', title: 'Estimated Completion Date', type: 'date' },
  { name: 'partsOrderedDate', title: 'Parts Ordered Date', type: 'date' },
  { name: 'partsArrivedDate', title: 'Parts Arrived Date', type: 'date' },
  { name: 'workStartedDate', title: 'Work Started Date', type: 'date' },
  { name: 'actualCompletionDate', title: 'Actual Completion Date', type: 'date' },
  { name: 'deliveredDate', title: 'Delivered Date', type: 'date' },
  { name: 'invoiceDate', title: 'Invoice Date', type: 'date' },
  { name: 'hashTags', title: 'Hash Tags' },
];

